export default [
	{
		SourceUnit: 'mg',
		DestinationUnit: 'g',
		Multiplier: 0.001,
	},
	{
		SourceUnit: 'kg',
		DestinationUnit: 'g',
		Multiplier: 1000,
	},
	{
		SourceUnit: 'yr',
		DestinationUnit: 'd',
		Multiplier: 365.2,
	},
	{
		SourceUnit: 'yr',
		DestinationUnit: 'wk',
		Multiplier: 52.178571,
	},
	{
		SourceUnit: 'yr',
		DestinationUnit: 'mo',
		Multiplier: 12,
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: 'mmol/mol',
		DestinationUnit: '%',
		conversion: 'value x 0.09148 + 2.152',
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: '%',
		DestinationUnit: 'mmol/mol',
		conversion: 'value x 10.93 - 23.5',
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: 'mg/dL',
		DestinationUnit: '%',
		conversion: 'value / 28.7 + 1.62718',
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: 'mmol/L',
		DestinationUnit: '%',
		conversion: 'value / 1.98 + 2.1666',
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: '%',
		DestinationUnit: 'mg/dL',
		conversion: 'value x 28.7 - 46.7',
	},
	{
		RootTerm: {
			Name: 'HbA1c',
		},
		SourceUnit: '%',
		DestinationUnit: 'mmol/L',
		conversion: 'value x 1.98 - 4.29',
	},
	{
		SourceUnit: 'copies/mL',
		DestinationUnit: 'log10 copies/mL',
		conversion: 'log(value)'
	},
	{
		SourceUnit: 'log10 copies/mL',
		DestinationUnit: 'copies/mL',
		conversion: 'value^10'
	}
]
